import _ from 'lodash';

import { CreateEditUsageEnum } from 'Common/FieldEnum';

export const basicURL = '/usage';
export const getSaveObject = (values, OpType, usageId) => {
  let saveObj = {
    UsageId: usageId,
    SiteId: values[CreateEditUsageEnum.Site],
    Comments: values[CreateEditUsageEnum.Comments],
    DateUsage: values[CreateEditUsageEnum.UsageDT],
    OpType: OpType,
    UsageItems: [],
  };
  _.forEach(values[CreateEditUsageEnum.UsageItemsInfo], item => {
    if (item[CreateEditUsageEnum.PriQty] || item[CreateEditUsageEnum.SecQty]) {
      const obj = {
        ItemId: item[CreateEditUsageEnum.ItemId],
        ItemCode: item[CreateEditUsageEnum.ItemCode],
        ItemDescription: item[CreateEditUsageEnum.Description],
        PriQtyUsed: item[CreateEditUsageEnum.PriQty],
        Unit: item[CreateEditUsageEnum.Unit],
        SecQtyUsed: item[CreateEditUsageEnum.SecQty],
        SecondaryUnit: item[CreateEditUsageEnum.SecondaryUnit],
        QtyPerUnit: item[CreateEditUsageEnum.QtyPerUnit],
        PrimaryQty: item[CreateEditUsageEnum.PrimaryQty],
        SecondaryQty: item[CreateEditUsageEnum.SecondaryQty],
        PrimaryPrice: item[CreateEditUsageEnum.PrimaryPrice],
      };
      saveObj.UsageItems.push(obj);
    }
  });
  return saveObj;
};

export const filterDataSource = (
  usageItemsInfo,
  usageItemsData,
  change,
  fieldName
) => {
  if (
    usageItemsInfo &&
    usageItemsInfo.length &&
    usageItemsData &&
    usageItemsData.length
  ) {
    const dataSourceCopy = _.cloneDeep(usageItemsData);
    const valueCopy = _.cloneDeep(usageItemsInfo);
    const removeValues = [];
    let index;
    _.each(valueCopy, item => {
      index = _.findIndex(dataSourceCopy, {
        [CreateEditUsageEnum.ItemCode]: item[CreateEditUsageEnum.ItemCode],
      });
      if (index === -1) {
        removeValues.push({ ...item });
      }
    });
    removeValues.length && _.pullAllBy(valueCopy, removeValues, 'ItemCode');
    change(fieldName, valueCopy);
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/helper/index.js